import React from 'react';
import { SiteSection, SiteSectionHeader } from '../../components/site';
import type { SolutionSaaSModule, SolutionSaaSModules } from './types';

function ModuleIllustration({ kind }: { kind: SolutionSaaSModule['illustration'] }) {
  switch (kind) {
    case 'access':
      return (
        <svg viewBox="0 0 120 72" fill="none" aria-hidden>
          <rect x="44" y="28" width="32" height="28" rx="5" stroke="currentColor" strokeWidth="1.5" />
          <path d="M52 28V22a8 8 0 0 1 16 0v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="60" cy="42" r="3" fill="currentColor" opacity="0.55" />
        </svg>
      );
    case 'energy':
      return (
        <svg viewBox="0 0 120 72" fill="none" aria-hidden>
          <path d="M62 10 44 40h16l-6 22 28-34H66l6-18Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
      );
    case 'rooms':
      return (
        <svg viewBox="0 0 120 72" fill="none" aria-hidden>
          <rect x="10" y="16" width="100" height="44" rx="6" stroke="currentColor" strokeWidth="1.5" />
          <rect x="20" y="26" width="30" height="22" rx="3" stroke="currentColor" strokeWidth="1.25" opacity="0.7" />
        </svg>
      );
    case 'guest-app':
      return (
        <svg viewBox="0 0 120 72" fill="none" aria-hidden>
          <rect x="40" y="8" width="40" height="56" rx="8" stroke="currentColor" strokeWidth="1.5" />
          <rect x="46" y="16" width="28" height="34" rx="4" stroke="currentColor" strokeWidth="1.25" opacity="0.65" />
        </svg>
      );
    case 'operations':
      return (
        <svg viewBox="0 0 120 72" fill="none" aria-hidden>
          <rect x="22" y="20" width="76" height="36" rx="6" stroke="currentColor" strokeWidth="1.5" />
          <path d="M34 32h24M34 40h16M70 32h16" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" opacity="0.5" />
        </svg>
      );
    case 'analytics':
      return (
        <svg viewBox="0 0 120 72" fill="none" aria-hidden>
          <path d="M14 56V18M14 56h92" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M26 46l18-16 16 10 28-26" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    default:
      return null;
  }
}

export const SolutionHospitalityModules: React.FC<{
  modules: SolutionSaaSModules;
}> = ({ modules }) => (
  <SiteSection id="modules" className="hosp-modules hosp-modules--matrix">
    <SiteSectionHeader
      eyebrow={modules.eyebrow}
      title={modules.title}
      subtitle={modules.subtitle}
      align="center"
    />

    <div className="hosp-modules__matrix">
      <ul className="hosp-modules__grid">
        {modules.items.map((item, index) => (
          <li
            key={item.id}
            className={`hosp-modules__cell hosp-modules__cell--${index + 1}`}
          >
            <div className="hosp-modules__cell-inner">
              <span className="hosp-modules__index-bg" aria-hidden>
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="hosp-modules__watermark" aria-hidden>
                <ModuleIllustration kind={item.illustration} />
              </div>
              <header className="hosp-modules__head">
                <div className="hosp-modules__head-text">
                  <span className="hosp-modules__emoji" aria-hidden>
                    {item.emoji}
                  </span>
                  <h3 className="hosp-modules__title">{item.title}</h3>
                </div>
              </header>
              <p className="hosp-modules__desc">{item.description}</p>
              <p className="hosp-modules__tags-line">{item.tags.join(' · ')}</p>
              <span className="hosp-modules__metric">{item.metric}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </SiteSection>
);
